import React, { useState, useEffect } from 'react';

function CountdownTimer({ startTimestamp }) {
  const [timeDisplay, setTimeDisplay] = useState('');

  useEffect(() => {
    if (!startTimestamp) return;

    // Convert the start timestamp to milliseconds.
    const targetTime = startTimestamp * 1000;

    function updateTimer() {
      const now = Date.now();
      let diff = targetTime - now;

      // If the target time is reached or passed, stop the timer.
      if (diff <= 0) {
        setTimeDisplay("Claim started!");
        return;
      }

      // Calculate hours, minutes, and seconds.
      const hours = Math.floor(diff / (1000 * 60 * 60));
      diff %= (1000 * 60 * 60);
      const minutes = Math.floor(diff / (1000 * 60));
      diff %= (1000 * 60);
      const seconds = Math.floor(diff / 1000);

      // Format the time as HH:MM:SS with leading zeros.
      const formattedTime = 
        String(hours).padStart(2, '0') + ':' +
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0');

      setTimeDisplay(`Claim starts in ${formattedTime}`);
    }

    // Update immediately and then every second.
    updateTimer();
    const intervalId = setInterval(updateTimer, 1000);

    // Clear interval on component unmount.
    return () => clearInterval(intervalId);
  }, [startTimestamp]);

  return <div>{timeDisplay}</div>;
}

export default CountdownTimer;
